export default "__VITE_ASSET__DCgznWRP__"